import React, { useState, useEffect, useCallback } from 'react';
import { Eye, X } from 'lucide-react';
import { platformAPI } from '../services/api';
import { toast } from 'sonner';

export default function ReadonlyBanner() {
  const [session, setSession] = useState(null);

  const refresh = useCallback(() => {
    platformAPI.currentReadonly()
      .then((r) => setSession(r.data?.active || null))
      .catch(() => setSession(null));
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 10000);
    return () => clearInterval(id);
  }, [refresh]);

  const endSession = async () => {
    try {
      await platformAPI.endReadonly();
      toast.success('Exited client-view mode');
      setSession(null);
    } catch {
      toast.error('Failed to exit session');
    }
  };

  if (!session) return null;

  return (
    <div
      data-testid="readonly-banner"
      role="status"
      aria-live="polite"
      className="sticky top-0 z-30 bg-amber-500 text-amber-950 px-4 py-2 flex items-center justify-between gap-3 shadow-md"
    >
      <div className="flex items-center gap-2 text-sm font-semibold">
        <Eye className="w-4 h-4 shrink-0" />
        <span>
          Viewing as: <strong>{session.company_name}</strong> (Read-only)
        </span>
        <span className="hidden sm:inline text-xs opacity-75">
          — all write actions are disabled
        </span>
      </div>
      <button
        onClick={endSession}
        data-testid="readonly-banner-exit"
        className="flex items-center gap-1.5 px-3 py-1 text-xs font-bold bg-amber-950 text-amber-100 rounded hover:bg-amber-900 transition-colors"
      >
        <X className="w-3.5 h-3.5" />
        Exit
      </button>
    </div>
  );
}
